import React, { Component } from "react";
import { connect } from "react-redux";
import store from "../../../store";
import { getFormsAwaitingApproval } from "../../../actions/formActions";
import { generatePDF, clearPdfData } from "../../../actions/pdfActions";
import PDFObject from "pdfobject";
import _ from "lodash";
import {
  Layout,
  Row,
  Col,
  Table,
  Button,
  Modal,
  Form,
  Input,
  message,
  Spin,
  Icon,
  DatePicker,
  notification
} from "antd";
import SignaturePad from "react-signature-pad-wrapper";
import CustomSteps from "../../common/CustomSteps";
import CustomApproval from "../../common/CustomApproval";
import styled from "styled-components";
import moment from "moment";
import jspdf from "jspdf";
import { approveForm } from "../../../utils/api";

const FormItem = Form.Item;

const CustomLayout = styled(Layout)`
  && {
    min-height: 100vh;
    width: 100vw;
    background: rgb(0, 69, 124);
  }
`;

const CustomRow = styled(Row)`
  && {
    background: #fff;
    width: 90%;
    border-radius: 15px;
    margin: 50px auto;
  }
`;

const CustomCol = styled(Col)`
  && {
    padding: 15px 0px;
    box-shadow: rgba(0, 0, 0, 0.8) 0 20px 60px -10px;

    @media (min-width: 768px) {
      padding: 25px 0px;
    }

    @media (min-width: 992px) {
      padding: 50px 0px;
    }
  }
`;

const Logo = styled.img`
  display: block;
  margin: 0px auto 25px auto;
  width: 90%;

  @media (min-width: 768px) {
    width: auto;
  }
`;

const CustomButton = styled(Button)`
  && {
    margin: 3px;
    color: #fff;
    border: none;
    border-radius: 6px;
    background ${props => props.background};

    :active,
    :focus,
    :hover {
      background: ${props => props.background};
      color: #fff;
      border: none;
      opacity: 0.7
    }
  }
`;

const FormInput = styled(FormItem)`
  && {
    div input {
      border-radius: 15px;
      background: #dfe6e9;
      border: none;

      ::placeholder {
        color: rgba(0, 0, 0, 0.65);
      }
    }
  }
`;

const SignaturePadCol = styled(Col)`
  && {
    padding: 0px !important;
    margin: 0;
    box-shadow: rgba(0, 0, 0, 0.2) 0 20px 60px -10px;
    border-radius: 15px;
  }
`;

const ClearButton = styled(Button)`
  && {
    width: 100%;
    border-left: none;
    border-right: none;
    border-bottom: none;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;

    :active,
    :focus,
    :hover {
      border: none;
    }
  }
`;

const ViewPDFModal = styled(Modal)`
  && {
    & .ant-modal-content > .ant-modal-footer > div > .ant-btn:first-child {
      display: none;
    }
  }
`;

const TransitionDiv = styled.div`
  transition: 1.5s all;
`;

const CustomTable = styled(Table)`
  && {
    & td p {
      margin: 0;
    }
  }
`;

class AdminDashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      current: "home",
      searchText: "",
      data: [],
      filteredData: [],
      filteringDataLoading: false,
      modalVisible: false,
      modalFormId: "",
      modalViewPdfVisible: false,
      startValue: null,
      endValue: null,
      endOpen: false
    };
  }

  componentDidMount = () => {
    this.setState({
      data: this.props.getFormsAwaitingApproval(
        this.props.auth.user.userProfile.role
      )
    });
  };

  componentDidUpdate = prevProps => {
    if (
      this.props.forms.awaitingApproval !== prevProps.forms.awaitingApproval
    ) {
      let tableData = [];

      if (this.props.auth.user.userProfile.role === "HS_SENIOR_DIRECTOR") {
        if (!_.isEmpty(this.props.forms.awaitingApproval)) {
          tableData = this.props.forms.awaitingApproval
            .map(form => {
              return {
                key: form.id,
                formId: `#${form.formNumber}`,
                date: moment(form.formSubmissionTimeStamp).format(
                  "MMMM DD, YYYY"
                ),
                name: form.data["Full Name"],
                division: form.data["Division"],
                status: form.approvals
              };
            })
            .filter(form => {
              if (
                form.status[0].approvingAuthority ===
                  "head_start_community_partnerships_manager" ||
                form.status[0].approvingAuthority ===
                  "head_start_assistant_director_operations" ||
                form.status[0].approvingAuthority ===
                  "head_start_assistant_director_childcare_partnerships"
              ) {
                return form;
              }
            });
        }
      } else {
        if (!_.isEmpty(this.props.forms.awaitingApproval)) {
          tableData = this.props.forms.awaitingApproval.map(form => {
            return {
              key: form.id,
              formId: `#${form.formNumber}`,
              date: moment(form.formSubmissionTimeStamp).format(
                "MMMM DD, YYYY"
              ),
              name: form.data["Full Name"],
              division: form.data["Division"],
              status: form.approvals
            };
          });
        }
      }

      this.setState({
        data: tableData
      });
    }
  };

  disabledStartDate = startValue => {
    const endValue = this.state.endValue;
    if (!startValue || !endValue) {
      return false;
    }
    return startValue.valueOf() > endValue.valueOf();
  };

  disabledEndDate = endValue => {
    const startValue = this.state.startValue;
    if (!endValue || !startValue) {
      return false;
    }
    return endValue.valueOf() <= startValue.valueOf();
  };

  onChange = (field, value) => {
    this.setState({
      [field]: value
    });
  };

  onStartChange = value => {
    this.onChange("startValue", value);
  };

  onEndChange = value => {
    this.onChange("endValue", value);
  };

  handleStartOpenChange = open => {
    if (!open) {
      this.setState({ endOpen: true });
    }
  };

  handleEndOpenChange = open => {
    this.setState({ endOpen: open });
  };

  handleSearch = confirm => {
    const { startValue, endValue } = this.state;

    if (startValue !== null && endValue !== null) {
      this.setState({
        filteringDataLoading: true
      });

      const filteredData = this.state.data
        .map(d => {
          if (moment(d.date).isBetween(startValue, endValue)) {
            return d;
          }
        })
        .filter(data => data !== undefined);
        
      this.setState({
        filteredData: filteredData,
        filteringDataLoading: false
      });

      confirm();
    } else {
      if (startValue === null && endValue !== null) {
        message.error("Must select a Start Date");
      } else if (endValue === null && startValue !== null) {
        message.error("Must select a End Date");
      } else {
        message.error("Must select a Start Date and End Date");
      }
    }
  };

  handleReset = confirm => {
    this.setState({
      startValue: null,
      endValue: null,
      filteredData: []
    });
  };

  createFormsInDateRange = data => {
    const toDataURL = url =>
      fetch(url)
        .then(response => response.blob())
        .then(
          blob =>
            new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.onloadend = () => resolve(reader.result);
              reader.onerror = reject;
              reader.readAsDataURL(blob);
            })
        );

    const { startValue, endValue } = this.state;
    let doc = new jspdf("p", "mm", "a4");
    let logo = new Image();
    let y = 75;

    toDataURL("/assets/img/hcdelogo.png").then(dataUri => {
      logo.src = dataUri;

      doc.addImage(logo, "PNG", 55, 20, 0, 0);
      doc.setFontSize(12);
      doc.text("Form Number", 15, 60);
      doc.text("Date Submitted", 55, 60);
      doc.text("Submitted By", 105, 60);
      doc.text("Division", 150, 60);

      doc.setFontSize(10);
      data.forEach((d, i) => {
        if (i > 0) {
          y += 8;
        }

        doc.text(d.formId, 15, y);
        doc.text(
          moment(d.formSubmissionTimeStamp).format("MMMM DD, YYYY"),
          55,
          y
        );
        doc.text(d.name, 105, y);
        doc.text(d.division, 150, y);
      });

      y += 20;
      doc.text(`Total: ${data.length}`, 151, y);

      doc.save(
        `Forms from ${moment(startValue).format("MMMM DD, YYYY")} to ${moment(
          endValue
        ).format("MMMM DD, YYYY")}`
      );
    });
  };

  exportSelected = confirm => {
    const { startValue, endValue } = this.state;

    const filteredData = this.state.data
      .map(d => {
        if (moment(d.date).isBetween(startValue, endValue)) {
          return d;
        }
      })
      .filter(data => data !== undefined);

    if (_.isEmpty(filteredData)) {
      message.info("There is no data for the selected date range");
    } else {
      this.createFormsInDateRange(filteredData);
    }
  };

  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div
        style={{
          padding: 12,
          background: "#fff",
          boxShadow: "rgba(0,0,0,0.2) 0 9px 30px -10px",
          borderRadius: 12
        }}
      >
        <Row style={{ marginBottom: 10 }}>
          <Col span={24}>
            <DatePicker
              disabledDate={this.disabledStartDate}
              format="MMMM DD, YYYY"
              value={this.state.startValue}
              placeholder="Start Date"
              onChange={this.onStartChange}
              onOpenChange={this.handleStartOpenChange}
            />
          </Col>
        </Row>
        <Row style={{ marginBottom: 10 }}>
          <Col span={24}>
            <DatePicker
              disabledDate={this.disabledEndDate}
              format="MMMM DD, YYYY"
              value={this.state.endValue}
              placeholder="End Date"
              onChange={this.onEndChange}
              open={this.state.endOpen}
              onOpenChange={this.handleEndOpenChange}
              onOk={this.handleEndDateOk}
            />
          </Col>
        </Row>
        <Row gutter={16} style={{ marginBottom: 4 }}>
          <Col span={12}>
            <Button
              onClick={() => this.handleReset(confirm)}
              icon="undo"
              size="small"
              style={{ width: "100%" }}
            >
              Reset
            </Button>
          </Col>
          <Col span={12}>
            <Button
              type="primary"
              onClick={() => this.handleSearch(confirm)}
              icon="search"
              size="small"
              style={{ width: "100%" }}
            >
              Search
            </Button>
          </Col>
        </Row>
        {this.state.startValue !== null && this.state.endValue !== null ? (
          <Row>
            <Col span={24}>
              <CustomButton
                background="#00b894"
                icon="export"
                size="small"
                onClick={confirm => this.exportSelected(confirm)}
                style={{ width: "100%" }}
              >
                Export Selected
              </CustomButton>
            </Col>
          </Row>
        ) : (
          ""
        )}
      </div>
    ),
    filterIcon: filtered => (
      <Icon type="filter" style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    render: text => <p>{text}</p>
  });

  handleModalOk = modal => {
    if (modal === "viewpdf") {
      this.setState({
        modalViewPdfVisible: false
      });
    } else {
      this.setState({
        modalVisible: false
      });

      this.props.getFormsAwaitingApproval(
        this.props.auth.user.userProfile.role
      );
    }
  };

  handleModalCancel = modal => {
    if (modal === "viewpdf") {
      this.setState({
        modalViewPdfVisible: false
      });
    } else {
      this.setState({
        modalVisible: false
      });
    }
  };

  showModal = (modal, formId) => {
    if (modal === "viewpdf") {
      this.props.generatePDF(formId.slice(1));

      this.setState({
        modalViewPdfVisible: true,
        modalFormId: formId
      });
    } else {
      this.setState({
        modalVisible: true,
        modalFormId: formId
      });
    }
  };

  embedPDF = uri => {
    PDFObject.embed(uri, document.getElementById("preview-pane"));
  };

  render() {
    const { loading } = this.props.forms;
    const WrappedApprovalForm = Form.create()(ApprovalForm);

    const columns = [
      {
        title: "Form ID",
        dataIndex: "formId",
        key: "formId",
        sorter: (a, b) => a.formId.length - b.formId.length
      },
      {
        title: "Date Submitted",
        dataIndex: "date",
        key: "date",
        sorter: (a, b) => a.date.length - b.date.length,
        ...this.getColumnSearchProps("date")
      },
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
        sorter: (a, b) => a.name.length - b.name.length
      },
      {
        title: "Divison",
        dataIndex: "division",
        key: "division",
        sorter: (a, b) => a.name.length - b.name.length
      },
      {
        title: "Action",
        key: "action",
        sorter: (a, b) => a.status.length - b.status.length,
        defaultSortOrder: "ascend",
        render: (text, record) => {
          const { role } = this.props.auth.user.userProfile;

          return (
            <CustomApproval
              role={role}
              approval={record.status}
              formId={record.formId}
              showModal={this.showModal}
            />
          );
        }
      },
      {
        title: "View/Download",
        key: "viewDownload",
        render: (text, record) => (
          <span>
            <CustomButton
              background="#0984e3"
              icon="file-pdf"
              style={{ margin: 3 }}
              onClick={() => this.showModal("viewpdf", record.formId)}
            >
              View
            </CustomButton>
            <CustomButton
              background="#00b894"
              icon="download"
              style={{ margin: 3 }}
              loading={this.props.pdf.downloading}
              onClick={() =>
                this.props.generatePDF(record.formId.slice(1), true)
              }
            >
              Download
            </CustomButton>
          </span>
        )
      }
    ];

    return (
      <CustomLayout>
        <CustomRow type="flex" justify="center">
          <CustomCol span={24}>
            <Logo src="/assets/img/hcdelogo.png" />
            <CustomTable
              loading={loading || this.state.filteringDataLoading}
              columns={columns}
              dataSource={
                _.isEmpty(this.state.filteredData)
                  ? this.state.data
                  : this.state.filteredData
              }
              pagination={{ pageSize: 15 }}
              expandedRowRender={record => {
                return (
                  <CustomSteps
                    role={this.props.auth.user.userProfile.role}
                    approvals={record.status}
                  />
                );
              }}
              title={() => (
                <h1 style={{ textAlign: "center" }}>Submitted Forms</h1>
              )}
            />
            <WrappedApprovalForm
              handleModalOk={this.handleModalOk}
              handleModalCancel={this.handleModalCancel}
              modalFormId={this.state.modalFormId}
              modalVisible={this.state.modalVisible}
              userProfile={this.props.auth.user.userProfile}
            />
            <ViewPDFModal
              title={`${this.state.modalFormId}`}
              onOk={() => this.handleModalCancel("viewpdf")}
              onCancel={() => this.handleModalOk("viewpdf")}
              visible={this.state.modalViewPdfVisible}
              width={800}
              afterClose={() => store.dispatch(clearPdfData())}
            >
              <TransitionDiv
                id="preview-pane"
                style={{
                  height: this.props.pdf.done ? 650 : 0
                }}
              >
                <div>
                  {this.props.pdf.done ? (
                    this.embedPDF(this.props.pdf.uri)
                  ) : (
                    <Spin />
                  )}
                </div>
              </TransitionDiv>
            </ViewPDFModal>
          </CustomCol>
        </CustomRow>
      </CustomLayout>
    );
  }
}

class ApprovalForm extends Component {
  handleModalOk = e => {
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (this.signaturePad.isEmpty()) {
          message.error("You must provide your signature");
        } else {
          let d = new moment();
          const submittedBy = this.props.userProfile.title
            .replace(/of/g, "")
            .replace(/[^a-zA-z0-9]/g, "_")
            .replace(/__/g, "_")
            .toLowerCase();

          let approvalRequest = Object.assign(
            {},
            {
              name: values.name,
              approvingAuthority: submittedBy,
              decision: "Approved",
              date: moment(d).format("MMMM-DD-YYYY HH:mm:ss"),
              file: {
                fileName: `${this.props.userProfile.role}_SIGNATURE.png`,
                fileType: "image/png",
                data: this.signaturePad.toDataURL("image/png")
              }
            }
          );

          console.log("calling approval request: ", approvalRequest);
          approveForm(this.props.modalFormId.slice(1), approvalRequest)
            .then(res => {
              this.props.handleModalOk();
              notification.success({
                message: "Form Approved",
                description: "Form successfully approved!"
              });
            })
            .catch(err => {
              console.log(err);
            });
        }
      }
    });
  };

  handleModalCancel = () => {
    this.props.handleModalCancel();
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <div>
        <Modal
          title={`Approve Form: ${this.props.modalFormId}`}
          visible={this.props.modalVisible}
          onOk={this.handleModalOk}
          onCancel={this.handleModalCancel}
        >
          <Row>
            <Col span={24} style={{ margin: "15px 0" }}>
              <Form onSubmit={this.handleModalOk}>
                <FormInput>
                  {getFieldDecorator("name", {
                    rules: [
                      { required: true, message: "Please input your name!" }
                    ]
                  })(<Input placeholder="Enter your full name" />)}
                </FormInput>
              </Form>
            </Col>
            <p
              style={{
                textAlign: "center",
                fontStyle: "italic",
                margin: 0
              }}
            >
              Sign below
            </p>
            <SignaturePadCol span={24}>
              <SignaturePad
                ref={ref => (this.signaturePad = ref)}
                style={{ width: "75%" }}
              />
              <ClearButton onClick={() => this.signaturePad.clear()}>
                Clear
              </ClearButton>
            </SignaturePadCol>
          </Row>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  forms: state.forms,
  pdf: state.pdf
});

export default connect(
  mapStateToProps,
  { getFormsAwaitingApproval, generatePDF }
)(AdminDashboard);
